module.exports = __webpack_public_path__ + "static/media/result-1-zh-HK.3987c374.png";